import React from 'react';
import { ControlsServiceProvider } from '../../automaticPanel/panelsService/ControlsServiceContext';
import { GlobalDesignActionPanel } from '../types';
import { SpacingControls } from './components/SpacingControls';

const SpacingStyles: GlobalDesignActionPanel = (props) => {
  return (
    <ControlsServiceProvider host={props.host}>
      <SpacingControls />
    </ControlsServiceProvider>
  );
};

export default SpacingStyles;
